module.exports = __webpack_public_path__ + "img/monument_of_wind_stream_small.4f5203e7.png";